/**
 * メッセージテンプレートに関連するセレクター関数を提供するモジュール
 * @date 2025/06/25
 */
import { MessageTemplate, MessageTemplateFormType, MessageTemplateId } from './type';

/**
 * MessageTemplateのフィールド名を型安全に取得する
 * @param key MessageTemplateのキー
 * @returns 入力されたキーをそのまま返す
 */
export function getFieldName<K extends keyof MessageTemplate>(key: K): K {
  return key;
}

/**
 * 文字列をMessageTemplateIdに変換する
 * @param id 変換する文字列
 * @returns MessageTemplateId型にキャストされた文字列
 */
export function toMessageTemplateId(id: string): MessageTemplateId {
  return id as MessageTemplateId;
}

/**
 * MessageTemplateオブジェクトをフォーム用の形式に変換する
 * @param messageTemplate 変換元のMessageTemplateオブジェクト
 * @returns MessageTemplateFormType形式に変換されたオブジェクト
 */
export function toFormTypeFromMessageTemplate(messageTemplate: MessageTemplate): MessageTemplateFormType {
  return {
    messageTemplate: messageTemplate,
    ...messageTemplate,
    title: messageTemplate.title ?? null,
    category: messageTemplate.category,
    usage: messageTemplate.usage,
    altText: messageTemplate.broadCastMessage?.altText ?? null,
    tempLabel: messageTemplate.broadCastMessage?.tempLabel ?? null,
    tempUri: messageTemplate.broadCastMessage?.tempUri ?? null,
    text: messageTemplate.broadCastMessage?.text ?? null,
    type: messageTemplate.broadCastMessage?.type ?? 'text',
  };
}
